module.exports = __webpack_public_path__ + "img/127ne.99dd3648.svg";